import forEach from 'lodash/forEach';
import map from 'lodash/map';

import { TYPE, TABLE, SEAT, SEATRADIUS, DOUBLE_PI } from '@/constants';
import { Table } from './table';
import { TableSeat } from './tableSeat';

export default class RoundedTable extends Table {
  constructor(params = {}) {
    super(params);
    this.initView();
    this.render();
  }

  get subtype() {
    return TYPE.TABLE_ROUNDED;
  }

  get seatsTotal() {
    return this.seatsCount + this.openSpaces;
  }

  get openSpaces() {
    return this.attributes.openSpaces;
  }

  set openSpaces(value) {
    this.setAttribute('openSpaces', value);
    this.render();
  }

  get radius() {
    return this.attributes.radius;
  }

  set radius(value) {
    this.setAttribute('radius', value);
    this.shape.radius(this.attributes.radius);
    this.render();
  }

  changeRadiusManually(value) {
    this.setAttribute('autoRadius', false);
    this.radius = value;
  }

  initView() {
    const [x, y] = this.attributes.position;
    this.view.addClass('table-rounded');
    this.label = this.createLabel(x, y);
    this.seatsGroup = this.canvas.group().addClass('table-seats');
    this.shape = this.canvas.circle(this.radius * 2 * this.app.seatmap.scale).addClass('table-shape');
    forEach(this.seats, (seat) => this.seatsGroup.add(seat.view));
    this.view.add(this.shape).add(this.seatsGroup).add(this.label);
    this.shape.center(x, y);
    this.label.front();
    // this.view.scale(this.app.seatmap.scale);
    if (!this.app.showLabels) this.hideLabel();
  }

  render() {
    if (this.attributes.autoRadius) this.adjustRadius();
    if (this.seatsCount) this.renderSeats();
    this.view.untransform().transform({ rotation: this.attributes.rotation });
  }

  adjustRadius() {
    if (TABLE.ROUNDED.AUTO_RADIUS_COEF !== this.radius / this.seatsTotal) {
      const r = this.seatsTotal * TABLE.ROUNDED.AUTO_RADIUS_COEF;
      if (r < TABLE.ROUNDED.RADIUS / 2) return;
      this.radius = r;
    }
  }

  renderSeats() {
    const dr = (this.radius + SEATRADIUS) * this.app.seatmap.scale;
    const angle = DOUBLE_PI / this.seatsTotal;
    forEach(this.seats, (seat) => {
      const da = angle * seat.attributes.orderid;
      const dx = this.x + Math.sin(da) * dr;
      const dy = this.y + Math.cos(da) * dr;
      seat.attributes.position = [dx, dy];
      seat.redraw();
    });
  }

  clone(options) {
    const { keepPosition, keepLabel, ts } = options;
    const tableJson = this.toJSON(keepLabel);
    if (!keepPosition) {
      const [x, y] = tableJson.attributes.position;
      tableJson.attributes.position = [x + 50, y + 50];
    }
    if (!keepLabel) delete tableJson.attributes.label;
    tableJson.uuid = this.getUniqueId();
    if (ts) tableJson.options = options;
    return RoundedTable.fromJSON(tableJson, true);
  }

  static fromJSON(params, clone = false) {
    if (params.seats && clone) {
      params.seats = map(params.seats, (seatParams) => TableSeat.clone(seatParams, params.options));
    } else if (params.seats) {
      params.seats = map(params.seats, (seatParams) => TableSeat.fromJSON(seatParams));
    }
    params.attributes.label =
      params.attributes.label !== undefined && params.attributes.label !== '' ? params.attributes.label : SEAT.LABEL;
    return RoundedTable.create(params);
  }

  static create(params) {
    const attributes = {
      label: SEAT.LABEL,
      autoRadius: true,
      openSpaces: 0,
      radius: TABLE.ROUNDED.RADIUS,
      position: [0, 0],
      rotation: 0,
      isGrouped: false,
    };
    params.attributes = Object.assign({}, attributes, params.attributes);
    return new RoundedTable(params);
  }

  onScaleChange() {
    this.shape.radius(this.radius * this.app.seatmap.scale);
    this.renderSeats();
  }
}
